<template>
  <div>
    <div 
      class="table_actions_create_order action-chip action-chip--accent" 
      @click="openOrderSidebar(row.item.order_id, '', {tab: 23})"
    >
      <span class="table_actions_create_order-title action-chip__label">В&nbsp;заказ&nbsp;</span>
    </div>
  </div>
</template>
<script>
import { checkActionAllow } from "@/mixins";
import { openOrderSidebar } from "@/mixins/openOrderSidebar";

export default {
  props: {
    row: { type: Object, required: true }, // Row of table
    actionAllows: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    }, // Array of rules for action allows
  },
  mixins: [
    checkActionAllow, 
    openOrderSidebar
  ],
  data() {
    return {};
  },
  computed: {
    stacked() {
      const stackedBreakpoints = ["sm"];
      return stackedBreakpoints.includes(this.$mq);
    },
    responsive() {
      const responsiveBreakpoints = ["md", "lg", "xl"];
      return responsiveBreakpoints.includes(this.$mq);
    },
  },
  methods: {
  },
};
</script>

